/**
 * Navigazione interna protetta dall'open redirect (CWE-601).
 *
 * Del valore ricevuto (URL assoluto o relativo) tiene solo percorso, query e frammento:
 * la destinazione è sempre sull'origine della pagina, qualunque host contenga il valore.
 * Gli schemi diversi da http/https (javascript:, data:, blob:, ...) vengono rifiutati.
 * Ogni navigazione verso un URL letto dal DOM deve passare da qui.
 */
export const SafeUrl = {
  /**
   * @param {string} raw URL letto dal DOM (data-*, value di select/radio, ...)
   * @returns {string|null} percorso interno ("/..."), oppure null se il valore non è utilizzabile
   */
  internalPath(raw) {
    if (typeof raw !== 'string' || raw.trim() === '') return null;
    let url;
    try {
      url = new URL(raw, window.location.href);
    } catch (e) {
      return null;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    // Il parser ha già convertito i backslash in "/". Togliere le barre iniziali impedisce che
    // "//host" diventi un URL protocol-relative.
    return `/${url.pathname.replace(/^\/+/, '')}${url.search}${url.hash}`;
  },

  /** Naviga verso il percorso interno; restituisce false (e non naviga) se il valore è scartato. */
  navigate(raw) {
    const path = SafeUrl.internalPath(raw);
    if (path === null) return false;
    window.location.href = path;
    return true;
  },
};
